import React from 'react'
import { styled } from '@mui/material/styles'
import { decodeTrademarkEntity } from '@helpers/string-helper'
import { useTest } from '@hooks/useTest'
import { useBaseCollectionTileContext } from '../BaseCollectionTileContext'

const StyledDescription = styled('div')(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.primary.dark,
  marginBottom: '4px',
  [theme.breakpoints.up('md')]: {
    fontSize: '16px',
  },
}))

const Description = () => {
  const { collection } = useBaseCollectionTileContext()
  const { description } = collection ?? {}
  const { generateTestId } = useTest()
  if (!description) {
    return null
  }

  return (
    <StyledDescription data-testid={generateTestId('collection-tile', 'description')}>
      {decodeTrademarkEntity(description)}
    </StyledDescription>
  )
}

export default Description
